<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { select_value } from "svelte/internal";
  import { Icon, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane } from "sveltestrap";
  import { error, success } from "../../../../../public/my-theme";
  import type { Fn } from "../../../../global";
  import type { Complainant } from "../../../../Model/Complainant";
  import type { ComplainantGeneral } from "../../../../Model/ComplainantGeneral";
  import type { Third } from "../../../../Model/Third";
  import { complainantGeneralService, complainantService } from "../../../../services";
  import ComplaintInfoForm from "../../ComplaintInfoForm.svelte";
  import VehicleInput from "../../../VehicleInput.svelte";
  import AddVehicleList from "../../../AddVehicleList.svelte";
    import { dateInputFormatter } from "../../../../services/Functions";

  export let complainantThird: Third;
  export let diligenceId: string;
  export let open = false;
  export let toggle: Fn = undefined;

  $: load(diligenceId, complainantThird)

  let size = "lg";
  let complainant: Complainant;
  let complainantGeneral: ComplainantGeneral;
  let editVehicle: boolean = false;
  let license_expiration: string;

  const dispatch = createEventDispatcher();

  async function load(diligenceId, complainantThird){
    if (diligenceId && complainantThird) {

      let complainants: Complainant[] = await complainantService.findByDiligenceNumber(diligenceId)
      complainant = complainants.find(c => c.complainantThirId == complainantThird.id)

      if (complainant) {
        complainantGeneral = await complainantGeneralService.findOne(complainant.diligenceNumber/* , complainant.complainantThirId */);
        license_expiration = dateInputFormatter(complainantGeneral.licenseExpiration);
      }

    }
  }


  async function saveComplainantTraffic() {
    try {
      save()
      toggle()
      success("Datos guardados con exito");
    } catch (err) {
      error("Comprueba los campos");
    }
  }

  async function changeThirdList(third){
    complainant.complainantThirId = third.id;
    complainantGeneral.complainantThirId = third.id;
    save()
  }

  async function save(){
    await Promise.all([ 
      complainantService.saveComplainant(complainant),
      complainantGeneralService.saveComplainantGeneral(complainantGeneral)
    ])

    dispatch('saveComplainant');
  }

  async function changeVehicleEvent(vehicleId) {
    complainantGeneral.vehicleId = vehicleId;
    editVehicle = false
    save();
  }


</script>

<Modal isOpen={open} {toggle} {size}>
  <ModalHeader {toggle}>Editar</ModalHeader>
  <ModalBody>

    <TabContent>
      <TabPane tabId="Datos" tab="Datos" active>
        {#if complainant}
          <ComplaintInfoForm complainant={complainant} on:changeThirdLIst={(event) => changeThirdList(event.detail)}/>
        {/if}
      </TabPane>
      {#if complainantGeneral}
        <TabPane tabId="1" tab="General">
          <div class="mt-3">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-9 col-md-9">Muesta parte de causa?</div>
                  <div class="col-3 col-md-3">
                    <Input
                      type="select"
                      id="wantToDeclare"
                      value={complainantGeneral.showPartCause ? 1 : 0}
                      on:change={(event) => {
                        complainantGeneral.showPartCause = Boolean(
                          select_value(event.target)
                        );
                      }}>
                      <option value={1}>Si</option>
                      <option value={0}>No</option>
                    </Input>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-9 col-md-9">¿Resnuncia Restitución de causa?</div>
                  <div class="col-3 col-md-3">
                    <Input
                      type="select"
                      id="wantToDeclare"
                      value={complainantGeneral.resignationRestitutionCause ? 1 : 0}
                      on:change={(event) => {
                        complainantGeneral.resignationRestitutionCause = Boolean(
                          select_value(event.target)
                        );
                      }}>
                      <option value={1}>Si</option>
                      <option value={0}>No</option>
                    </Input>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 mt-3">
                <div class="row">
                  <div class="col-9 col-md-9">¿Renuncia a reparación de daño?</div>
                  <div class="col-3 col-md-3">
                    <Input
                      type="select"
                      id="wantToDeclare"
                      value={complainantGeneral.resignationRepairDamage ? 1 : 0}
                      on:change={(event) => {
                        complainantGeneral.resignationRepairDamage = Boolean(
                          select_value(event.target)
                        );
                      }}>
                      <option value={1}>Si</option>
                      <option value={0}>No</option>
                    </Input>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 mt-3">
                <div class="row">
                  <div class="col-9 col-md-9">¿Renuncia a indenimzación?</div>
                  <div class="col-3 col-md-3">
                    <Input
                      type="select"
                      id="interpreter"
                      value={complainantGeneral.indemnificationWaiver ? 1 : 0}
                      on:change={(event) => {
                        complainantGeneral.indemnificationWaiver = Boolean(
                          select_value(event.target)
                        );
                      }}>
                      <option value={1}>Si</option>
                      <option value={0}>No</option>
                    </Input>
                  </div>
                </div>
              </div>
        
              <div class="col-12 col-md-6 mt-3">
                <div class="row">
                  <div class="col-9 col-md-9">¿Sospecha de alguien?</div>
                  <div class="col-3 col-md-3">
                    <Input
                      type="select"
                      id="wantToDeclare"
                      value={complainantGeneral.suspectSomeone ? 1 : 0}
                      on:change={(event) => {
                        complainantGeneral.suspectSomeone = Boolean(
                          select_value(event.target)
                        );
                      }}>
                      <option value={1}>Si</option>
                      <option value={0}>No</option>
                    </Input>
                  </div>
                </div>
              </div>
        
              <div class="col-12 col-md-6 mt-3">
                <div class="row">
                  <div class="col-9 col-md-9">¿Denunció anteriormente?</div>
                  <div class="col-3 col-md-3">
                    <Input
                      type="select"
                      id="wantToDeclare"
                      value={complainantGeneral.denouncePreviously ? 1 : 0}
                      on:change={(event) => {
                        complainantGeneral.denouncePreviously = Boolean(
                          select_value(event.target)
                        );
                      }}>
                      <option value={1}>Si</option>
                      <option value={0}>No</option>
                    </Input>
                  </div>
                </div>
              </div>
              
              <div class="col-12 col-md-6 mt-3">
                <div class="row">
                  <div class="col-9 col-md-9">¿Solicita abogado?</div>
                  <div class="col-3 col-md-3">
                    <Input
                      type="select"
                      id="wantToDeclare"
                      value={complainantGeneral.appointsLawyer ? 1 : 0}
                      on:change={(event) => {
                        complainantGeneral.appointsLawyer = Boolean(
                          select_value(event.target)
                        );
                      }}>
                      <option value={1}>Si</option>
                      <option value={0}>No</option>
                    </Input>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 mt-3">
                <div class="row">
                  <div class="col-9 col-md-9">¿Justicia gratuita?</div>
                  <div class="col-3 col-md-3">
                    <Input
                      type="select"
                      id="wantToDeclare"
                      value={complainantGeneral.freeJustice ? 1 : 0}
                      on:change={(event) => {
                        complainantGeneral.freeJustice = Boolean(
                          select_value(event.target)
                        );
                      }}>
                      <option value={1}>Si</option>
                      <option value={0}>No</option>
                    </Input>
                  </div>
                </div>
              </div>
        
              <div class="col-12 mt-3">
                <Label for="mark">Parte Facultativo</Label>
                <Input
                type="textarea"
                id="lawyerPart"
                rows={6}
                bind:value={complainantGeneral.lawyerPart}/>
              </div>
        
              <div class="col-12 col-md-6 mt-3">
                <div class="row">
                  <div class="col-12 mb-3 mt-2">
                    <Label for="matricula">Matricula</Label>
                    <div class="input-group">
                      <VehicleInput id={complainantGeneral.vehicleId} />
                      <button
                        class="btn btn-secondary"
                        type="button"
                        id="complainantThirId"
                        name="complainantThirId"
                        on:click={() => { editVehicle = true; }}>
                        <Icon name="plus" />
                      </button>
                    </div>
                  </div>

                  {#if editVehicle}
                    <AddVehicleList on:changeVehicle={(event) => changeVehicleEvent(event.detail)} />
                  {/if}

                </div>
              </div>
        
              <div class="col-12 mt-3">
                <Label for="mark">Desperfecto de vehículos</Label>
                <Input
                type="textarea"
                id="vehicleDamage"
                rows={6}
                bind:value={complainantGeneral.vehicleDamage}/>
              </div>
        
              <div class="col-12 col-md-6 mt-3">
                <div class="row">
                  <div class="col-9 col-md-6">Matrícula de Remolque</div>
                  <div class="col-3 col-md-6">
                    <Input
                      type="text"
                      id="optionalPart"
                      bind:value={complainantGeneral.trailerPlate} />
                  </div>
                </div>
              </div>
        
              <div class="col-12 col-md-6 mt-3">
                <div class="row">
                  <div class="col-9 col-md-9">¿Poseé Seguro?</div>
                  <div class="col-3 col-md-3">
                    <Input
                      type="select"
                      id="wantToDeclare"
                      value={complainantGeneral.ownsSecurity ? 1 : 0}
                      on:change={(event) => {
                        complainantGeneral.ownsSecurity = Boolean(
                          select_value(event.target)
                        );
                      }}>
                      <option value={1}>Si</option>
                      <option value={0}>No</option>
                    </Input>
                  </div>
                </div>
              </div>
              <div class="col-3 mt-3">
                <Label>Permiso de conducir</Label>
                <Input
                  type="select"
                  id="wantToDeclare"
                  value={complainantGeneral.drivingLicense ? 1 : 0}
                  on:change={(event) => {
                    complainantGeneral.drivingLicense = Boolean(
                      select_value(event.target)
                    );
                  }}>
                  <option value={1}>Si</option>
                  <option value={0}>No</option>
                </Input>
              </div>
              <div class="col-6 mt-3">
                <Label>Periodo de validez</Label>
                <Input
                    type="date"
                    on:change={() => {complainantGeneral.licenseExpiration = new Date(license_expiration)}}
                    bind:value={license_expiration}
                  />
              </div>
            </div>
          </div>
        </TabPane>
      
      {/if}

    </TabContent>
  </ModalBody>
  <ModalFooter>
    <button class="btn btn-success" type="button" on:click={saveComplainantTraffic}>Guardar</button>
  </ModalFooter>
</Modal>

